export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

export const extractWindows = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== 'object') return [];
  const keys = ['items', 'data', 'leagues', 'windows'];
  for (let i = 0; i < keys.length; i += 1) {
    const value = payload[keys[i]];
    if (Array.isArray(value)) return value;
  }
  return [];
};

export const extractWindow = (payload) => {
  if (!payload || typeof payload !== 'object') return null;
  if (Array.isArray(payload)) return payload[0] || null;
  if (payload.id != null || payload.league_id != null) return payload;
  const nested = payload.data || payload.league || payload.item || payload.window;
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) return nested;
  return extractWindows(payload)[0] || null;
};

export const isTransferWindowConfigured = (league) => (
  league != null && (
    league.windowSchedulerDayFrom != null
    || league.windowSchedulerDayTo != null
    || Boolean(league.windowSchedulerTimeFrom)
    || Boolean(league.windowSchedulerTimeTo)
    || league.windowSchedulerEnabled != null
  )
);

export const isTransferWindowEnabled = (league) => Number(league?.windowSchedulerEnabled) === 1;

export const isSeasonWindowOpen = (item) => Number(item?.application_active) === 1;

export const extractSeasonWindows = (payload) => {
  const league = extractWindow(payload);
  if (!league) return { league: null, seasons: [] };
  const seasons = Array.isArray(league.seasons)
    ? league.seasons
    : extractWindows(league);
  return { league, seasons };
};

export const getBrowserTimezoneOffset = () => -new Date().getTimezoneOffset();

export const resolveTimezoneOffset = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : getBrowserTimezoneOffset();
};

export const normalizeWeekday = (value) => {
  const day = Number(value);
  if (!Number.isFinite(day)) return null;
  if (day === 7) return 0;
  if (day >= 0 && day <= 6) return day;
  return null;
};

export const parseTimeParts = (value) => {
  const match = String(value || '').trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = Number(match[3] || 0);
  if (hours > 23 || minutes > 59 || seconds > 59) return null;
  return { hours, minutes, seconds };
};

export const formatTimeInput = (value) => {
  const parts = parseTimeParts(value);
  if (!parts) return '';
  return `${String(parts.hours).padStart(2, '0')}:${String(parts.minutes).padStart(2, '0')}`;
};

export const toTimePayload = (value) => formatTimeInput(value) || null;

export const weekdayLabelKey = (day) => {
  const weekday = normalizeWeekday(day);
  return weekday == null ? '' : `twDay${weekday}`;
};

export const formatWindowWeekdays = (item, t) => {
  const fromDay = normalizeWeekday(item?.windowSchedulerDayFrom);
  const toDay = normalizeWeekday(item?.windowSchedulerDayTo);
  if (fromDay == null || toDay == null) return '—';
  const fromTime = formatTimeInput(item?.windowSchedulerTimeFrom);
  const toTime = formatTimeInput(item?.windowSchedulerTimeTo);
  const from = t(`twDayFrom${fromDay}`);
  const to = t(`twDayTo${toDay}`);
  if (fromTime && toTime) {
    return t('twRangeTime', { from, fromTime, to, toTime });
  }
  return t('twRange', { from, to });
};

export const leagueFlagValue = (item) => {
  if (!item || typeof item !== 'object') return '';
  if (item.flag) return item.flag;
  if (item.country_flag) return item.country_flag;
  if (item.countryFlag) return item.countryFlag;
  if (typeof item.country === 'string') return item.country;
  if (item.country && typeof item.country === 'object') {
    return item.country.flag || item.country.code || item.country.name || '';
  }
  return '';
};

export const windowFormFromLeague = (league) => ({
  league_id: league?.id != null ? String(league.id) : '',
  enabled: league?.windowSchedulerEnabled == null ? true : isTransferWindowEnabled(league),
  dayFrom: league?.windowSchedulerDayFrom == null ? '' : String(normalizeWeekday(league.windowSchedulerDayFrom) ?? ''),
  timeFrom: formatTimeInput(league?.windowSchedulerTimeFrom),
  dayTo: league?.windowSchedulerDayTo == null ? '' : String(normalizeWeekday(league.windowSchedulerDayTo) ?? ''),
  timeTo: formatTimeInput(league?.windowSchedulerTimeTo),
  timezoneOffset: league?.windowSchedulerTimezoneOffset,
});
